import { render, staticRenderFns } from "./CampaignsCharts.component.vue?vue&type=template&id=23000d98&scoped=true&"
import script from "./CampaignsCharts.component.vue?vue&type=script&lang=js&"
export * from "./CampaignsCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsCharts.component.vue?vue&type=style&index=0&id=23000d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23000d98",
  null
  
)

export default component.exports